export default "__VITE_ASSET__BE4Kce_R__"